/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {internalProcessAliasEventSync} from '../api'

export const useMutationInternalProcessAliasEventSync = createReactQueryMutationHook('internalProcessAliasEventSync', internalProcessAliasEventSync)
